<template>
  <span style="display: flex" v-if="value > 0">
    <!--<span class="reaction-icon-text">{{ value }}</span>-->
    <!-- v-icon class="reaction-icon" :size="size" >{{ icon }}</v-icon -->
    <span :class="'reaction-icon material-icons reaction-icon-' + icon">{{
      icon
    }}</span>
  </span>
</template>
<script>
import Vue from "vue";
import { REACTIONS } from "@/helpers/chat";

export default Vue.extend({
  name: "ReactionSelector",
  props: {
    value: { type: Number },
    icon: { type: String },
    size: { type: Number }
  },
  data() {
    return {
      reactions: REACTIONS
    };
  },
  methods: {
    handleClick(reaction) {
      this.$emit("react", reaction);
    }
  }
});
</script>
<style scoped>
.reaction-icon {
  font-size: 14px;
  padding-left: 2px;
  padding-right: 2px;
  margin-top: -1px;
  color: rgba(125, 129, 134);
}

.reaction-icon-priority_high,
.reaction-icon-question_mark {
  text-shadow: 1px 0 0 rgba(125, 129, 134);
}

.reaction-icon-text {
  opacity: 0.8;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
}
</style>
